import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Spin } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';

const TabAmort = (props: { form?: any; data: any[] }) => {
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});

  useEffect(() => {
    forceUpdate({});
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: 'N° Échéance',
      dataIndex: 'NumeroEch',
      key: 'NumeroEch',
      width: 120,
      align: 'center',
      render: (text: any) => (
        <span style={{ fontWeight: 500, color: '#1890ff' }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Date Échéance',
      dataIndex: 'DateEcheance',
      key: 'DateEcheance',
      width: 150,
      align: 'center',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
      key: 'CapitalInitial',
      width: 160,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'Amortissement',
      dataIndex: 'Armotissement',
      key: 'Armotissement',
      width: 160,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
     {
      title: 'Charge',
      dataIndex: 'PartCharge',
      key: 'PartCharge',
      width: 160,
      align: 'right',
      render: (text: any) => (
        <span style={{ fontWeight: 500 }}>
          {Number(text ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
    {
      title: 'Marge HT',
      dataIndex: 'PartMargeHT',
      key: 'PartMargeHT',
      width: 160,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'TVA',
      dataIndex: 'PartTVA',
      key: 'PartTVA',
      width: 160,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'Annuité',
      dataIndex: 'Annuite',
      key: 'Annuite',
      width: 160,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    // {
    //   title: 'Capital Restant',
    //   dataIndex: 'CapitalRestant',
    //   key: 'CapitalRestant',
    //   width: 180,
    //   align: 'right',
    //   render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    // },
    {
      title: 'Solde Restant TTC',
      dataIndex: 'SoldeRestantTTC',
      key: 'SoldeRestantTTC',
      width: 180,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
  ];

  return (
    <div className='tabItem'>
        <Box fontStyle='inherit' className='border' height={'60%'} width={'85%'} position={'absolute'}>
         <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <Table size='small' columns={columns} dataSource={props.data} scroll={{ y: 220, x: 'max-content' }} pagination={false} />
                
                <Box display={'flex'} width={'100%'} marginTop={'5%'} fontStyle='inherit' className='border-left bordure1 tabElement2'>
                  <InputForm money notRequired disabled width={8} label='Montant demandé' name='MontantDemande' type='number' error='mobile' />
                </Box>
              </Box>
             </Box> 
    </div>
  );
};

export default TabAmort;
